import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styled, { CSSProperties } from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';
import { range } from 'lib/arrays';
import { Color } from 'style/types';

const Root = styled(Horizontal)`
  --active-color: var(--c-black);
  --color: var(--c-nd-600);
  --nb-items: 3;

  flex: 1;
  & > :first-child {
    flex: 1;
  }
`;

const ProgressWrapper = styled.div`
  width: calc(100% / var(--nb-items));
  height: var(--unit);
  border-radius: 2px;
  background-color: var(--color);
  &.filled {
    background-color: var(--active-color);
  }
  &.highlightNext {
    background-color: var(--highlight-next-color);
  }
`;

type Props = {
  progress: number | null;
  target: number | null;
  color?: Color;
  activeColor?: Color;
  highlightNextColor?: Color;
  className?: string;
};
export const Progress = ({
  progress,
  target,
  color,
  activeColor,
  highlightNextColor,
  className,
}: Props) => {
  if (!target) {
    return null;
  }

  return (
    <Root
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={target}
      aria-valuenow={progress || 0}
      className={className}
      gap={1}
      style={
        {
          '--color': color,
          '--active-color': activeColor,
          '--highlight-next-color': highlightNextColor,
          '--nb-items': target,
        } as CSSProperties
      }
    >
      <Horizontal gap={0.5}>
        {range(target).map(x => (
          <ProgressWrapper
            key={x}
            className={classnames({
              filled: x < (progress || 0),
              highlightNext: highlightNextColor && x === (progress || 0),
            })}
          />
        ))}
      </Horizontal>
      <LabelS>
        <Horizontal gap={0.5}>
          <FormattedMessage
            id="ManagerProgressionMissionContentTile.progression"
            defaultMessage="{progress}/{target}"
            values={{
              progress: (
                <LabelS
                  as="span"
                  color={highlightNextColor || activeColor}
                  bold
                >
                  {progress}
                </LabelS>
              ),
              target: <LabelS as="span">{target}</LabelS>,
            }}
          />
        </Horizontal>
      </LabelS>
    </Root>
  );
};
